"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLink = exports.Root = void 0;
var _mui = require("@ori-ui/mui");
var _styles = require("../styles");
const Root = exports.Root = (0, _mui.styled)('div')({
  textAlign: 'center'
});
const StyledLink = exports.StyledLink = (0, _mui.styled)(_mui.Link)(({
  theme
}) => ({
  lineHeight: 0,
  padding: theme.spacing(1),
  margin: theme.spacing(-1),
  display: 'block',
  svg: {
    fill: theme.palette.text.primary
  },
  ...(0, _styles.focusableStyle)(theme)
}));